import axios from "axios"
import React, {Component} from "react"
import ApiHelper from "src/ApiHelper"
import "bootstrap/dist/css/bootstrap.min.css"
import {reactLocalStorage} from "reactjs-localstorage"
import { withRouter } from "react-router-dom"
class LoginForm extends Component{
    constructor(props){
        super(props)
        this.state = {
            loginform: {
                email: "",
                password: "",
                errorMessage: ""
            }
        }
    }
    render(){
        return <div className="c_login_form_container">
                <div className="c_login_form_header">
                    <img alt="Arth" src="/logoimage.png" className="c_login_form_logo"/>
                </div>
                <div className="c_login_form_main">
                    <input className="c_login_form_input" type="email" onChange={this.emailIdChanged.bind(this)} value={this.state.loginform.email} placeholder="Email ID"/><br/>
                    <input className="c_login_form_input" type="password" onChange={this.passwordChanged.bind(this)} value={this.state.loginform.password} placeholder="Password"/><br/>
                    <button className="c_login_form_button" onClick={this.onSubmitClicked.bind(this)}>Submit</button>
                    <p className="text-danger">{this.state.loginform.errorMessage}</p>
                </div>
                <div className="c_login_form_footer"></div>
            </div>
    }
    emailIdChanged(event){
        const newstate = {...this.state}
        newstate.loginform.email = event.target.value
        this.setState(newstate)
    }
    passwordChanged(event){
        const newstate = {...this.state}
        newstate.loginform.password = event.target.value
        this.setState(newstate)
    }
    onSubmitClicked(){
        console.log(this.state.loginform.email)
        console.log(this.state.loginform.password)
        var attemptlogin = axios.post(ApiHelper.developerCredentials.login, {emailid: this.state.loginform.email, password: this.state.loginform.password})
        attemptlogin.then((data) => {
            reactLocalStorage.setObject(ApiHelper.localStorage.developerPortal, data.data.token)
            this.props.history.replace("/developerportal")
            console.log(this.props)
        }, (error) => {
            const newstate = {...this.state}
            newstate.loginform.errorMessage = error.response.data.error_message
            this.setState(newstate)
        }).catch((error) => {
            const newstate = {...this.state}
            newstate.loginform.errorMessage = "An Error Occured"
            this.setState(newstate)
        })
    }
    componentDidMount(){
        
    }
}
export default withRouter(LoginForm)